import { getProjectRef } from "./ProjectRepository";
import { db } from "@/main";
import { ProjectNote, NoteChange } from "../models/ProjectNote";
import { ProjectSyncTarget } from "../models/ProjectDetails";
import { buildSyncedNoteUpdate } from "@/utils/SyncedNoteUpdate";
import { ProjectStatusSyncStatus } from "../models/ProjectState";

function getProjectNotesRef(projectId: string) {
  return db
    .doc(getProjectRef(projectId))
    .collection("syncedNotes")
    .doc("data");
}

export function updateNote(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  noteUpdate: any,
  projectId: string,
  noteId: string,
  noteChange: NoteChange,
  projectSyncTarget?: ProjectSyncTarget
) {
  if (!noteId) {
    return null;
  }

  // Payload rules live in buildSyncedNoteUpdate so this writer and
  // ProjectLogRepository.saveSyncedProjectNote cannot drift apart.
  const update = buildSyncedNoteUpdate(
    noteId,
    noteUpdate,
    noteChange,
    ProjectStatusSyncStatus.NEEDS_SYNC,
    projectSyncTarget
  );

  return getProjectNotesRef(projectId).set(update, { merge: true });
}

export function observeNotesOfProject(
  projectId: string,
  callback: (notes: ProjectNote[]) => void
) {
  return getProjectNotesRef(projectId).onSnapshot((snapshot) => {
    const noteLogs = snapshot.get("notes");

    if (noteLogs) {
      const projectNotes = [];
      for (const noteId of Object.keys(noteLogs)) {
        const projectNote = noteLogs[noteId] as ProjectNote;

        if (projectNote) {
          projectNotes.push(projectNote);
        }
      }

      callback(
        projectNotes.sort(
          (n1, n2) =>
            n2.createdBy.recordedAt.toMillis() -
            n1.createdBy.recordedAt.toMillis()
        )
      );
    }
  });
}
